import React from 'react';
import PropTypes from 'prop-types';

import './FlagIcon.scss';

const FlagIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-FlagIcon ${activeStyle}`}
            viewBox="0 0 30 30"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="design:-Bias-for-Reaction"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="Exports" transform="translate(-826.000000, -317.000000)">
                    <g
                        id="Icons/flag"
                        transform="translate(826.000000, 317.000000)"
                    >
                        <rect
                            id="Rectangle-Copy-2"
                            x="0"
                            y="0"
                            width="30"
                            height="30"
                        />
                        <g
                            id="Flag-2"
                            transform="translate(4.000000, 4.000000)"
                            fill="#8E9DB9"
                        >
                            <path
                                d="M5.5,4.18229167 L17.448897,7.54291894 C17.9373577,7.68029852 18.3333333,8.20336945 18.3333333,8.70737685 L18.3333333,9.62595649 C18.3333333,10.1316893 17.9410354,10.6520005 17.448897,10.7904144 L5.5,14.1510417 L5.5,19.2512413 C5.5,19.7568168 5.09312391,20.1666667 4.58333333,20.1666667 C4.07707231,20.1666667 3.66666667,19.7580442 3.66666667,19.2512413 L3.66666667,2.74875866 C3.66666667,2.24318321 4.07354275,1.83333333 4.58333333,1.83333333 C5.08959435,1.83333333 5.5,2.24195575 5.5,2.74875866 L5.5,4.18229167 Z M5.5,6.09747823 L5.51581186,12.2421313 L16.5,9.16980483 L5.5,6.09747823 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

FlagIcon.propTypes = {
    isActive: PropTypes.bool,
};

FlagIcon.defaultProps = {
    isActive: false,
};

FlagIcon.displayName = 'FlagIcon';

export default FlagIcon;
